<template>
    <div class="com-choose-item-pop-box">
        <i v-show="showPop" class="com-choose-triangle"></i>
        <van-popup :value="showPop" class="com-choose-item-popup" @click-overlay="clickCancel">
            <div class="com-choose-item-list clearfix">
                <div class="com-choose-item" v-for="item in itemList" v-bind:class="{'com-choose-item-six': itemList.length == 6 || itemList.length == 12, 'com-choose-item-cur': item.selected}" :key='"choose-item" + itemList.indexOf(item)' @click="clickItem(item)"><span v-bind:class="'wd-' + item.propXingEn">{{item.text}}</span></div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    name: 'ChooseItemPop',
    props: ['showPop', 'itemList', 'cancelFunc', 'itemFunc'],
    computed: {},
    methods: {
        clickCancel() {
            if(typeof(this.cancelFunc) == 'function'){
                this.cancelFunc();
            }
        },
        clickItem(data) {
            if(typeof(this.itemFunc) == 'function'){
                this.itemFunc(data);
            }
        }
    }
}
</script>